import { wrapRootElement as rootElement, wrapPageElement as pageElement, onRouteUpdate as routeUpdate } from './root';
//buildpls
export const wrapRootElement = rootElement;
export const wrapPageElement = pageElement;
export const onRouteUpdate = routeUpdate;
